import React, { memo } from "react";
import { Box, CircularProgress } from "@mui/material";

interface Props {
  // Optional testId so feature dialogs can keep their existing data-testid contracts
  // (e.g. "investor-request-loading-placeholder") when migrating to this shared component.
  testId?: string;
  height?: number | string;
}

const DialogLoadingPlaceholder = ({ testId = "dialog-loading-placeholder", height = 350 }: Props) => (
  <Box height={height} width="100%" display="flex" justifyContent="center" alignItems="center" data-testid={testId}>
    <CircularProgress />
  </Box>
);

export default memo(DialogLoadingPlaceholder);
